export default [
  {
    zh: '整机编号',
    en: 'Device Code',
    dataIndex: 'devicCode',
    key: 'deviceCode',
    width: 200
  },
  {
    zh: '公司名称',
    en: 'Company',
    dataIndex: 'company',
    key: 'company',
    width: 460
  },
  {
    zh: '机型',
    en: 'Model',
    dataIndex: 'model',
    key: 'model',
    width: 230
  },
  {
    zh: '排气压力(MPa)',
    en: 'Exhaust Pressure',
    dataIndex: 'exhaustPressure',
    key: 'exhaustPressure'
  },
  {
    zh: '排气温度(℃)',
    en: 'Exhaust Temperature(℃)',
    dataIndex: 'exhaustTemperature',
    key: 'exhaustTemperature'
  },
  {
    zh: '进油温度(℃)',
    en: 'Oil Inlet Temperature(℃)',
    dataIndex: 'oilInletTemperature',
    key: 'oilInletTemperature'
  }
]